/* MiaMia · páginas de aprendizaje.
   - drawTag(): dibuja una placa de acero con hasta 6 líneas centradas.
   - [data-mml-tag]: placas de ejemplo fijas (páginas por condición).
   - [data-mml-plan]: planificador de grabado (guía "What to engrave"). */
(function () {
  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;'); }
  function drawTag(lines, ghost) {
    var W = 360, H = 210, x = 20, y = 20, w = 320, h = 170;
    lines = lines.filter(function (l, i, a) { return l || a.slice(i).some(Boolean); });
    if (!lines.length) lines = [''];
    var n = lines.length, longest = Math.max.apply(null, lines.map(function (l) { return l.length; }).concat([8]));
    var fs = Math.min((h - 30) / (n * 1.25), (w - 40) / (longest * 0.6), 30), lh = fs * 1.24;
    var cy = y + h / 2, t = '';
    lines.forEach(function (l, i) {
      t += '<text x="' + (W / 2) + '" y="' + (cy - (n - 1) * lh / 2 + i * lh + fs * 0.35).toFixed(1) + '">' + esc(l) + '</text>';
    });
    var id = 'g' + Math.random().toString(36).slice(2, 7);
    return '<svg viewBox="0 0 ' + W + ' ' + H + '" role="img" aria-label="' + esc(lines.join(', ')) + '">' +
      '<defs><linearGradient id="' + id + '" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#eef0f2"/><stop offset="1" stop-color="#c9ced3"/></linearGradient></defs>' +
      '<rect x="' + x + '" y="' + y + '" width="' + w + '" height="' + h + '" rx="16" fill="url(#' + id + ')"/>' +
      '<g font-family="Arial, Helvetica, sans-serif" font-size="' + fs.toFixed(1) + '" fill="#3f454b" text-anchor="middle"' + (ghost ? ' opacity=".4"' : '') + '>' + t + '</g></svg>';
  }
  window.mmDrawTag = drawTag;

  document.querySelectorAll('[data-mml-tag]').forEach(function (el) {
    var lines = (el.getAttribute('data-mml-tag') || '').split('|');
    el.insertAdjacentHTML('afterbegin', drawTag(lines));
  });

  document.querySelectorAll('[data-mml-plan]').forEach(function (root) {
    var data;
    try { data = JSON.parse(root.querySelector('[data-mml-plan-data]').textContent); } catch (e) { return; }
    var inputs = Array.prototype.slice.call(root.querySelectorAll('.mml-plan__in'));
    var counts = Array.prototype.slice.call(root.querySelectorAll('.mml-plan__c'));
    var prev = root.querySelector('[data-mml-plan-preview]');
    var maxSel = root.querySelector('[data-mml-max]');
    var msg = root.querySelector('[data-mml-msg]');
    var sugg = root.querySelector('[data-mml-sugg]');
    var search = root.querySelector('[data-mml-search]');
    var tabs = root.querySelector('[data-mml-tabs]');
    var cat = Object.keys(data.suggestions)[0], last = null;
    function max() { return Number(maxSel.value) || 20; }
    function render() {
      var m = max(), any = false;
      inputs.forEach(function (i, k) {
        var len = i.value.length; any = any || !!i.value.trim();
        counts[k].textContent = len + '/' + m;
        counts[k].classList.toggle('is-over', len > m);
      });
      prev.innerHTML = any ? drawTag(inputs.map(function (i) { return i.value; })) : drawTag(['Jane Doe', 'Type 1 Diabetes', 'ICE: Mom', '407-555-0123'], true);
    }
    function say(t) { msg.textContent = t || ''; }
    function put(text) {
      var target = (last && !last.value) ? last : inputs.find(function (i) { return !i.value; });
      if (!target) { say('All 6 lines are full. Clear a line to add more.'); return; }
      target.value = text; target.focus(); last = target;
      say(text.length > max() ? '"' + text + '" is ' + text.length + ' characters, longer than ' + max() + '. Try a shorter version.' : '');
      render();
    }
    function drawSugg() {
      var q = (search.value || '').toLowerCase().trim();
      var list = q ? Object.keys(data.suggestions).reduce(function (a, k) { return a.concat(data.suggestions[k]); }, []).filter(function (s) { return s.toLowerCase().indexOf(q) !== -1; })
                   : data.suggestions[cat];
      sugg.innerHTML = '';
      list.forEach(function (s) {
        var b = document.createElement('button'); b.type = 'button'; b.textContent = s;
        b.addEventListener('click', function () { put(s); });
        sugg.appendChild(b);
      });
      if (!list.length) sugg.innerHTML = '<p class="mml-msg">No suggestions. Type your own wording in a line.</p>';
    }
    Object.keys(data.suggestions).forEach(function (k, idx) {
      var b = document.createElement('button'); b.type = 'button'; b.textContent = k; b.setAttribute('role', 'tab');
      b.setAttribute('aria-selected', idx === 0 ? 'true' : 'false');
      b.addEventListener('click', function () {
        cat = k; search.value = '';
        tabs.querySelectorAll('button').forEach(function (x) { x.setAttribute('aria-selected', x === b ? 'true' : 'false'); });
        drawSugg();
      });
      tabs.appendChild(b);
    });
    inputs.forEach(function (i) {
      i.addEventListener('input', render);
      i.addEventListener('focus', function () { last = i; });
    });
    maxSel.addEventListener('change', render);
    search.addEventListener('input', drawSugg);
    root.querySelectorAll('[data-mml-preset]').forEach(function (b) {
      b.addEventListener('click', function () {
        var lines = b.getAttribute('data-mml-preset').split('|');
        inputs.forEach(function (i, k) { i.value = lines[k] || ''; });
        say('Example loaded. Change the name and phone number to your own.');
        render();
        prev.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      });
    });
    root.querySelector('[data-mml-clear]').addEventListener('click', function () { inputs.forEach(function (i) { i.value = ''; }); say(''); render(); });
    root.querySelector('[data-mml-copy]').addEventListener('click', function () {
      var t = inputs.map(function (i) { return i.value.trim(); }).filter(Boolean).join('\n');
      if (!t) { say('Write at least one line first.'); return; }
      (navigator.clipboard ? navigator.clipboard.writeText(t) : Promise.reject()).then(function () {
        say('Copied. Paste each line into the engraving fields of your piece.');
      }, function () { say('Select the lines and copy them manually.'); });
    });
    drawSugg(); render();
  });
})();
